import { render, staticRenderFns } from "./BsSearchField.vue?vue&type=template&id=3198e80c&"
import script from "./BsSearchField.vue?vue&type=script&lang=js&"
export * from "./BsSearchField.vue?vue&type=script&lang=js&"
import style0 from "./BsSearchField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports